/* tslint:disable */
/* eslint-disable */
/**
 * Spazious Backoffice API
 * Spazious private JSON:API v3 specification
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface TokenAttributes
 */
export interface TokenAttributes {
    /**
     * 
     * @type {string}
     * @memberof TokenAttributes
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof TokenAttributes
     */
    password: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TokenAttributes
     */
    scopes?: Array<TokenAttributesScopesEnum>;
    /**
     * 
     * @type {string}
     * @memberof TokenAttributes
     */
    token?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum TokenAttributesScopesEnum {
    Readcrm = 'read:crm',
    Writecrm = 'write:crm',
    Updatecrm = 'update:crm',
    Deletecrm = 'delete:crm',
    SendEmailaccount = 'send_email:account',
    UpdateCommissionaccount = 'update_commission:account',
    ReadgenericOrders = 'read:generic-orders',
    WritegenericOrders = 'write:generic-orders',
    UpdategenericOrders = 'update:generic-orders',
    DeletegenericOrders = 'delete:generic-orders',
    ApplyDiscountgenericOrders = 'apply-discount:generic-orders',
    RefreshPricesgenericOrders = 'refresh-prices:generic-orders',
    ChangeRateCodegenericOrders = 'change-rate-code:generic-orders',
    ChangeCurrencygenericOrders = 'change-currency:generic-orders',
    ChangeStatusCompleteTransitionsgenericOrders = 'change-status-complete-transitions:generic-orders',
    ChangeStatusNoBackTransitionsgenericOrders = 'change-status-no-back-transitions:generic-orders',
    ReadgenericOrderActivities = 'read:generic-order-activities',
    WritegenericOrderActivities = 'write:generic-order-activities',
    UpdategenericOrderActivities = 'update:generic-order-activities',
    DeletegenericOrderActivities = 'delete:generic-order-activities',
    ApplyDiscountgenericOrderActivities = 'apply-discount:generic-order-activities',
    ApplyCommissiongenericOrderActivities = 'apply-commission:generic-order-activities',
    OverridePricegenericOrderActivities = 'override-price:generic-order-activities',
    RefreshPricegenericOrderActivities = 'refresh-price:generic-order-activities',
    ReadgenericGuestRoomRequest = 'read:generic-guest-room-request',
    WritegenericGuestRoomRequest = 'write:generic-guest-room-request',
    UpdategenericGuestRoomRequest = 'update:generic-guest-room-request',
    DeletegenericGuestRoomRequest = 'delete:generic-guest-room-request',
    ApplyDiscountgenericGuestRoomRequest = 'apply-discount:generic-guest-room-request',
    ApplyCommissiongenericGuestRoomRequest = 'apply-commission:generic-guest-room-request',
    OverridePricegenericGuestRoomRequest = 'override-price:generic-guest-room-request',
    RefreshPricegenericGuestRoomRequest = 'refresh-price:generic-guest-room-request',
    ReadgenericService = 'read:generic-service',
    WritegenericService = 'write:generic-service',
    UpdategenericService = 'update:generic-service',
    DeletegenericService = 'delete:generic-service',
    ApplyDiscountgenericService = 'apply-discount:generic-service',
    ApplyCommissiongenericService = 'apply-commission:generic-service',
    OverridePricegenericService = 'override-price:generic-service',
    RefreshPricegenericService = 'refresh-price:generic-service',
    ReadorderEventPackages = 'read:order-event-packages',
    WriteorderEventPackages = 'write:order-event-packages',
    UpdateorderEventPackages = 'update:order-event-packages',
    DeleteorderEventPackages = 'delete:order-event-packages',
    ApplyDiscountorderEventPackages = 'apply-discount:order-event-packages',
    ApplyCommissionorderEventPackages = 'apply-commission:order-event-packages',
    OverridePriceorderEventPackages = 'override-price:order-event-packages',
    RefreshPriceorderEventPackages = 'refresh-price:order-event-packages',
    Readusers = 'read:users',
    Readpayments = 'read:payments',
    Writepayments = 'write:payments',
    Updatepayments = 'update:payments',
    Deletepayments = 'delete:payments',
    ChangeStatuspayments = 'change-status:payments',
    Writepricing = 'write:pricing',
    ReadguestRoomAllotments = 'read:guest-room-allotments',
    WriteguestRoomAllotments = 'write:guest-room-allotments',
    UpdateguestRoomAllotments = 'update:guest-room-allotments',
    DeleteguestRoomAllotments = 'delete:guest-room-allotments',
    ReadguestRoomRates = 'read:guest-room-rates',
    WriteguestRoomRates = 'write:guest-room-rates',
    UpdateguestRoomRates = 'update:guest-room-rates',
    DeleteguestRoomRates = 'delete:guest-room-rates',
    WriteorderAttachments = 'write:order-attachments',
    UpdateorderAttachments = 'update:order-attachments',
    DeleteorderAttachments = 'delete:order-attachments',
    ReadorderAttachments = 'read:order-attachments',
    WriteorderNote = 'write:order-note',
    UpdateorderNote = 'update:order-note',
    DeleteorderNote = 'delete:order-note',
    ReadorderNote = 'read:order-note',
    Readtemplates = 'read:templates',
    Readhotels = 'read:hotels',
    Readservices = 'read:services',
    Deleteservices = 'delete:services',
    Updateservices = 'update:services',
    Writeservices = 'write:services',
    ReadserviceRates = 'read:service-rates',
    DeleteserviceRates = 'delete:service-rates',
    UpdateserviceRates = 'update:service-rates',
    WriteserviceRates = 'write:service-rates',
    ReadmeetingRooms = 'read:meeting-rooms',
    WritemeetingRooms = 'write:meeting-rooms',
    DeletemeetingRooms = 'delete:meeting-rooms',
    UpdatemeetingRooms = 'update:meeting-rooms',
    ReadmeetingRoomRates = 'read:meeting-room-rates',
    WritemeetingRoomRates = 'write:meeting-room-rates',
    DeletemeetingRoomRates = 'delete:meeting-room-rates',
    UpdatemeetingRoomRates = 'update:meeting-room-rates',
    ReadmeetingRoomBlocks = 'read:meeting-room-blocks',
    WritemeetingRoomBlocks = 'write:meeting-room-blocks',
    UpdatemeetingRoomBlocks = 'update:meeting-room-blocks',
    DeletemeetingRoomBlocks = 'delete:meeting-room-blocks',
    ReadmeetingRoomSetups = 'read:meeting-room-setups',
    WritemeetingRoomSetups = 'write:meeting-room-setups',
    UpdatemeetingRoomSetups = 'update:meeting-room-setups',
    DeletemeetingRoomSetups = 'delete:meeting-room-setups',
    ReadguestRooms = 'read:guest-rooms',
    WriteguestRooms = 'write:guest-rooms',
    UpdateguestRooms = 'update:guest-rooms',
    DeleteguestRooms = 'delete:guest-rooms',
    Readdiagramming = 'read:diagramming',
    Writediagramming = 'write:diagramming',
    Updatediagramming = 'update:diagramming',
    Deletediagramming = 'delete:diagramming',
    ReadvirtualMeetingRoomSetupLink = 'read:virtual-meeting-room-setup-link',
    WritevirtualMeetingRoomSetupLink = 'write:virtual-meeting-room-setup-link',
    UpdatevirtualMeetingRoomSetupLink = 'update:virtual-meeting-room-setup-link',
    DeletevirtualMeetingRoomSetupLink = 'delete:virtual-meeting-room-setup-link',
    ReadrateCodes = 'read:rate-codes',
    WriterateCodes = 'write:rate-codes',
    UpdaterateCodes = 'update:rate-codes',
    DeleterateCodes = 'delete:rate-codes',
    ReadorderReporting = 'read:order-reporting',
    ReaddiagrammingReporting = 'read:diagramming-reporting',
    ReadvirtualMeetingRoom = 'read:virtual-meeting-room',
    WritevirtualMeetingRoom = 'write:virtual-meeting-room',
    UpdatevirtualMeetingRoom = 'update:virtual-meeting-room',
    DeletevirtualMeetingRoom = 'delete:virtual-meeting-room',
    ReadvirtualFurniture = 'read:virtual-furniture',
    WritevirtualFurniture = 'write:virtual-furniture',
    UpdatevirtualFurniture = 'update:virtual-furniture',
    DeletevirtualFurniture = 'delete:virtual-furniture',
    ReadvirtualMeetingRoomSetup = 'read:virtual-meeting-room-setup',
    WritevirtualMeetingRoomSetup = 'write:virtual-meeting-room-setup',
    UpdatevirtualMeetingRoomSetup = 'update:virtual-meeting-room-setup',
    DeletevirtualMeetingRoomSetup = 'delete:virtual-meeting-room-setup',
    Readpackages = 'read:packages',
    Writepackages = 'write:packages',
    Updatepackages = 'update:packages',
    Deletepackages = 'delete:packages',
    ReadvirtualMeetingRoomSetupTemplate = 'read:virtual-meeting-room-setup-template',
    WritevirtualMeetingRoomSetupTemplate = 'write:virtual-meeting-room-setup-template',
    UpdatevirtualMeetingRoomSetupTemplate = 'update:virtual-meeting-room-setup-template',
    DeletevirtualMeetingRoomSetupTemplate = 'delete:virtual-meeting-room-setup-template',
    ReadhotelChainChoices = 'read:hotel-chain-choices',
    WritehotelChainChoices = 'write:hotel-chain-choices',
    UpdatehotelChainChoices = 'update:hotel-chain-choices',
    DeletehotelChainChoices = 'delete:hotel-chain-choices',
    ReadorderTasks = 'read:order-tasks',
    WriteorderTasks = 'write:order-tasks',
    UpdateorderTasks = 'update:order-tasks',
    DeleteorderTasks = 'delete:order-tasks',
    ReadvirtualObject = 'read:virtual-object',
    WritevirtualObject = 'write:virtual-object',
    UpdatevirtualObject = 'update:virtual-object',
    DeletevirtualObject = 'delete:virtual-object',
    Readcurrencies = 'read:currencies',
    ReadtaskAttachment = 'read:task-attachment',
    WritetaskAttachment = 'write:task-attachment',
    UpdatetaskAttachment = 'update:task-attachment',
    DeletetaskAttachment = 'delete:task-attachment',
    ReadeventPackageRates = 'read:event-package-rates',
    WriteeventPackageRates = 'write:event-package-rates',
    UpdateeventPackageRates = 'update:event-package-rates',
    DeleteeventPackageRates = 'delete:event-package-rates'
}

